import { Reveal } from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Send the material",
    copy: "You provide your all-hands deck or transcript, company updates, wins and recognition through an agreed private channel.",
  },
  {
    n: "02",
    title: "Build the draft",
    copy: "We turn those materials into a recap and copy-ready sections.",
  },
  {
    n: "03",
    title: "Review together",
    copy: "You check facts, names and sensitive details and request your included revision round.",
  },
  {
    n: "04",
    title: "Approve",
    copy: "You approve the final wording before anything is used.",
  },
  {
    n: "05",
    title: "Deliver",
    copy: "You receive the final editable document and share the approved email and Slack copy with your team.",
  },
];

export const Process = () => (
  <section id="how-it-works" data-testid="process-section" className="py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta">
          How it works
        </p>
        <h2 className="mt-5 max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight text-walnut sm:text-5xl">
          Five steps. You approve everything.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-8">
        {steps.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.1}>
            <div className="border-t-2 border-terracotta/30 pt-6">
              <p
                data-testid={`process-step-${i + 1}`}
                className="font-mono text-5xl font-medium text-terracotta/90"
              >
                {step.n}
              </p>
              <h3 className="mt-5 font-serif text-xl font-medium tracking-tight text-walnut">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-umber/85">{step.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p
          data-testid="process-partner-note"
          className="mt-14 rounded-2xl border border-line bg-paper px-6 py-5 text-sm leading-relaxed text-umber/85"
        >
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-terracotta">
            Culture Pulse Partner adds:
          </span>{" "}
          a five-question team check-in run through your own approved survey tool, a
          short themes brief for leaders, a 30-minute leader call, one agreed action,
          and a &ldquo;You said / We&rsquo;re doing&rdquo; update to close the loop.
        </p>
      </Reveal>
    </div>
  </section>
);
